import React from 'react'
import ReactTooltip from 'react-tooltip'
import StatusAlert from 'react-status-alert'
import '../css/react-status-alert.css'
import './Page.css'

const PageUI = ({ context, className, dimension, centered, children, headerLeft, headerRight, footer,
  sideBar, showSidebar }) =>
  <div className={`t_page g_flex_v ${className} ${sideBar ? 'sideBar' : ''} ${context.session.appCode}`}>
    <header>
      <div className='g_flex_h content'>
        {headerLeft}
        {headerRight}
      </div>
    </header>

    {
      sideBar &&
      <main role='main' className={`g_flex_v g_flex_top`}>
        <div className='g_flex_h' style={{ flexGrow: 1, width: '100%' }}>
          {
            showSidebar &&
            <div className='t_sidebar_wrapper'>
              {sideBar}
            </div>
          }
          <div className={`t_content`}
            style={{
              alignSelf: centered ? '' : 'flex-start',
              maxWidth: dimension == 'w768' ? '768px' : '',
              width: dimension === 'w1600' ? '1600px' : '768px'
            }} >
            {children}
          </div>
        </div>
      </main>
    }
    {
      !sideBar &&
      <main role='main' className={`${dimension || 'w768'} ${centered ? 'centered' : ''}`}>
        {children}
      </main>
    }
    <ReactTooltip />
    <StatusAlert />

    <footer>
      {footer}
    </footer>
  </div>

export default PageUI
